<template>
  <div id="mapContainerSig" class="fullHeight" />
</template>

<script>
import mapboxgl from 'mapbox-gl'

import environment from '../../environment'
import http from '../../utils/http'

const TEMP_MARKER = 'tempMarker'

export default {
  name: 'PointSigMapBox',
  props: {
    localId: String,
  },
  data() {
    return {
      map: null,
      markers: [],
      markerMap: {},
      icones: {
        hidrometro: require('@/assets/map/v1/100/hidrometro.png'),
        reservatorio: require('@/assets/map/v1/100/reservatorio.png'),
        tubulacao: require('@/assets/map/v1/100/tubulacao.png'),
        motoBomba: require('@/assets/map/v1/100/motobomba.png'),
        valvula: require('@/assets/map/v1/100/valvula.png'),
        vazamento: require('@/assets/map/v1/100/vazamento.png'),
      },
    }
  },
  async mounted() {
    mapboxgl.accessToken = environment.MAPBOXGL_ACCESSTOKEN

    const map = new mapboxgl.Map({
      container: 'mapContainerSig', // container ID
      style: 'mapbox://styles/mapbox/streets-v12', // style URL
      center: [-56.087104, -13.601664], // starting position [lng, lat]
      zoom: 9, // starting zoom
    })
    map.addControl(new mapboxgl.NavigationControl())

    this.map = map

    map.on('load', async () => {
      map.resize()

      await this.loadMarkers()
    })

    map.on('click', (e) => {
      this.$emit('click', e)
    })
  },
  methods: {
    async loadMarkers() {
      this.markers = (
        await http.get('ponto-sig/local/' + this.localId + '/pontos-resumidos')
      ).pontos

      this.showMarkers()

      if (this.markers[0]) {
        const marker = this.markers[0].localizacao
        this.flyTo(marker)
      }
    },
    flyTo({ lng, lat }) {
      this.map.flyTo({
        center: [lng, lat],
        zoom: 12,
      })
    },
    showMarkers() {
      this.markers.forEach((e) => {
        const el = this.createIcon(e.tipo)

        this.markerMap[e.id] = new mapboxgl.Marker(el)
          .setLngLat({
            lng: e.localizacao.lng,
            lat: e.localizacao.lat,
          })
          .addTo(this.map)

        this.markerMap[e.id].getElement().onclick = () => {
          this.$emit('marker-click', e)
        }

        this.markerMap[e.id].getElement().style.cursor = 'pointer'
      })
    },
    addTempMarker({ lng, lat }) {
      this.removeTempMarker()

      this.markerMap[TEMP_MARKER] = new mapboxgl.Marker()
        .setLngLat({
          lng: lng,
          lat: lat,
        })
        .addTo(this.map)
    },
    removeTempMarker() {
      this.markerMap[TEMP_MARKER]?.remove()
    },
    createIcon(tipo) {
      const el = document.createElement('div')
      const [width, height] = [80, 80]

      const url = this.obterIconePorTipo(tipo)

      el.className = 'marker'
      el.style.backgroundImage = `url(${url})`
      el.style.width = `${width}px`
      el.style.height = `${height}px`
      el.style.backgroundSize = '100%'

      return el
    },
    obterIconePorTipo(tipo) {
      switch (tipo) {
        case 1:
          return this.icones.tubulacao
        case 2:
          return this.icones.hidrometro
        case 3:
          return this.icones.reservatorio
        case 4:
          return this.icones.motoBomba
        case 5:
          return this.icones.valvula
        case 6:
          return this.icones.vazamento
      }
    },
  },
}
</script>

<style scoped lang="scss">
.fullHeight {
  min-height: 100%;
  height: 100%;
}
</style>
